import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import * as echarts from 'echarts';
import { onMounted } from 'vue';
import { toRefs } from 'vue';

type EChartsOption = echarts.EChartsOption


export default /*#__PURE__*/_defineComponent({
  __name: 'gauge',
  props: {
  chartId: {
    type: String,
    default: ''
  },
  percentage: {
    type: Number,
    default: 0
  },
  px: {
    type: Number,
    default: 100
  }
},
  setup(__props) {

const props = __props;

onMounted(() => {
  setTimeout(init, 100);
})


const { chartId, percentage, px } = toRefs(props);

const init = () => {
  var chartDom = document.getElementById(chartId.value)!;
  var myChart = echarts.init(chartDom);
  var option: EChartsOption;

  const gaugeData = [
    {
      value: 20,
      name: 'Perfect',
      detail: {
        valueAnimation: true,
        offsetCenter: ['0%', '0%']
      }
    }
  ];
  option = {
    series: [
      {
        type: 'gauge',
        startAngle: 90,
        endAngle: -270,
        pointer: {
          show: false
        },
        radius: px.value / 2 - 2,
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          itemStyle: {

            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
              // 四个数字分别对应 数组中颜色的开始位置，分别为 右，下，左，上。例如（1,0,0,0 ）代表从右边开始渐
              // 变。offset取值为0~1，0代表开始时的颜色，1代表结束时的颜色，柱子表现为这两种颜色的渐变。
              offset: 0,
              color: '#2B8EF3'
            }, {
              offset: 1,
              color: '#47E4E5'
            }]),
          }
        },
        axisLine: {
          lineStyle: {
            width: px.value / 10,
          }
        },
        splitLine: {
          show: false,
          distance: 0,
          length: px.value / 10,
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false,
        },
        data: gaugeData,
        title: {
          show: false
        },
        detail: {
          fontSize: px.value / 4,
          color: '#fff',
          formatter: '{value}%',

        }
      }
    ]
  };
  gaugeData[0].value = percentage.value;
  myChart.setOption<EChartsOption>(option);
  window.addEventListener('resize', () => {
    myChart.resize({ width: px.value, height: px.value });
    option = {
      series: [
        {
          type: 'gauge',
          startAngle: 90,
          endAngle: -270,
          pointer: {
            show: false
          },
          radius: px.value / 2 - 2,
          progress: {
            show: true,
            overlap: false,
            roundCap: true,
            clip: false,
            itemStyle: {

              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                // 四个数字分别对应 数组中颜色的开始位置，分别为 右，下，左，上。例如（1,0,0,0 ）代表从右边开始渐
                // 变。offset取值为0~1，0代表开始时的颜色，1代表结束时的颜色，柱子表现为这两种颜色的渐变。
                offset: 0,
                color: '#2B8EF3'
              }, {
                offset: 1,
                color: '#47E4E5'
              }]),
            }
          },
          axisLine: {
            lineStyle: {
              width: px.value/10,
            }
          },
          splitLine: {
            show: false,
            distance: 0,
            length: px.value/10
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false,
          },
          data: gaugeData,
          title: {
            show: false
          },
          detail: {
            fontSize: px.value / 4,
            color: '#fff',
            formatter: '{value}%',

          }
        }
      ]
    };
    myChart.setOption<EChartsOption>(option);
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _unref(chartId),
    style: _normalizeStyle('width:' + _unref(px) + 'px;' + 'height:' + _unref(px) + 'px;')
  }, null, 12, _hoisted_1))
}
}

})